export const getters = {
  company: state => state.company || (sessionStorage.getItem('company') && sessionStorage.getItem('company') !== 'undefined' ? JSON.parse(sessionStorage.getItem('company')) : null)
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/company/getters.js